import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { sessionApi, sessionKeys } from "./api";

export function useMe() {
  return useQuery({ queryKey: sessionKeys.me, queryFn: sessionApi.me });
}

export function useSignOut() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: sessionApi.logout,
    // Drop every cached answer: they belonged to the person who just left.
    onSuccess: () => queryClient.clear(),
  });
}
